
import {B2BAuthRepository} from "@/modules/b2bAuth/adapter/B2BAuthRepository";
import {Authorization} from "@aprocon-software/aprocon-auth-util";

export class B2BAuthPort implements B2BAuthRepository{
    private readonly b2BAuthRepository: B2BAuthRepository;

    constructor(params: { b2BAuthRepository: B2BAuthRepository }) {
        this.b2BAuthRepository = params.b2BAuthRepository;
    }

    public async login(userId: string, password: string, deviceId: string, branchId: string = ''): Promise<any> {
        return this.b2BAuthRepository.login(userId,password,deviceId,branchId);
    }

    public async logout(): Promise<any> {
        return this.b2BAuthRepository.logout();
    }

    public async keepAlive(): Promise<any> {
        return this.b2BAuthRepository.keepAlive();
    }
}
